<div class="content-without-stepper-and-title document-introduction" *ngIf="!grayZone">
  <div class="row">
    <div class="col-4 col-pr-12 col-sm-8 col-md-12 col-lg-12 col-xl-12">
      <div class="image">
        <img id="docIntroImg" src="assets/images/check_phone.svg" alt="{{copyService.copies.document_introduction_alt_image}}" />
      </div>
      <div id="docIntroTitle" class="title">{{copyService.copies.request_received_title}}</div>
      <div id="docIntroTitle" class="subtitle">{{copyService.copies.request_received_subtitle}} </div>
      <div id="docIntroTitle" class="subtitle strong">{{copyService.copies.request_received_subtitle_a}} </div>
      <div id="docIntroTitle" class="sub_subtitle">{{solicitationNumber}} </div>
    </div>
  </div>
  <app-controls id="docIntroBtns" [nextLabel]="copyService.copies.four_tax_warning_text_footer_button" (next)="nextYes()"></app-controls>
</div>

<div class="successfulAccountCreation" *ngIf="grayZone">
  <div class="row">
    <div class="col-4 col-pr-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 offset-md offset-lg offset-xl-2">
        <div class="wrap">
            <h1 id="successful-title" class="title">
                {{copyService.getParametrizedCopy('successful_account_creation_title_revolving_zng', [documentInfo.firstname])}}
            </h1>
            <div class="box-desc">
                <div class="detail">
                    <div class="case-id">
                        <p class="subtitle subtitle-light">{{ copyService.copies.successful_account_creation_account_numberCredit_label_zng}}</p>
                        <p>{{solicitationNumber}}</p>
                    </div>
                    <!-- <div class="case-id" *ngIf="productClient">
                        <p class="subtitle subtitle-light">{{ copyService.copies.successful_account_creation_account_selected}}</p>
                        <p>{{accountNumber}}</p>
                    </div> -->
                    <div class="case-id">
                        <p class="subtitle subtitle-light">{{ copyService.copies.detail_bonding_solicitation_date}}</p>
                        <p> {{ currentDate }}</p>
                    </div>
                    <div class="case-id">
                        <p class="subtitle subtitle-light">{{ copyService.copies.successful_account_creation_ip_address}}</p>
                        <p> {{ ipAddress }}</p>
                    </div>
                </div>
                <div class="extra-text">
                    <label>{{ copyService.copies.successful_account_creation_extra_text_zng }}</label>
                </div>
                <br>
                <div class="extra-text">
                    <label>{{ copyService.copies.successful_account_creation_extra_text_zng2 }}</label>
                </div>
                <br>
                <br>
            </div>
            <br>
        </div>
    </div>
  </div>
</div>
<div class="aditional-info" *ngIf="grayZone">
  <app-controls id="successBtns" [nextLabel]="copyService.copies.four_tax_warning_text_footer_button" (next)="nextYes()"></app-controls>
</div>